export const getFocusedField = () => {
	const element = document.activeElement;
	return element instanceof HTMLInputElement ||
		element instanceof HTMLTextAreaElement
		? element
		: null;
};
